import { axiosBaseQuery, getClient, getCurrentDomain } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'
import { API_BASE, createRequestFacade } from 'apps-common'
import { ActivityState } from '@/api/models/activity'
import { Collection } from './showcasesApi'

const BASE_ENDPOINT = 'public/open-catalog'

export type PublicObjective = {
  code: string
  imageUrl: string | null
  about: string | null
  description: string | null
  showcases: Collection[]
  availabilityDate: string | null
  availabilityEndDate: string | null
  state: ActivityState
  id: string
  name: string
}

export type PublicObjectiveQueryModel = {
  data: PublicObjective[]
  totalCount: number
  groupCount: number
  summary: any
}

export const publicClient = getClient({ isPublic: true })

const publicRequest = createRequestFacade(publicClient, API_BASE.LMS)

export const publicCatalogApi = createApi({
  reducerPath: 'publicCatalogApi',
  baseQuery: axiosBaseQuery(publicRequest),
  endpoints: (build) => ({
    fetchPublicCatalogObjectives: build.query<PublicObjectiveQueryModel, void>({
      query: () => {
        const domain = getCurrentDomain()
        const sort = `[{ selector: 'name', desc: false }]`
        const requireTotalCount = true

        return {
          url: `${BASE_ENDPOINT}/objectives/query`,
          method: 'get',
          params: {
            query: {
              domain: encodeURIComponent(domain),
              sort,
              requireTotalCount,
            },
          },
        }
      },
    }),
    fetchPublicCatalogObjectiveById: build.query<PublicObjective, string>({
      query: (id) => {
        const domain = getCurrentDomain()

        return {
          url: `${BASE_ENDPOINT}/objectives/${id}`,
          method: 'get',
          params: {
            query: {
              domain: encodeURIComponent(domain),
            },
          },
        }
      },
    }),
    fetchPublicCatalogShowcases: build.query<Collection[], void>({
      query: () => {
        const domain = getCurrentDomain()

        return {
          url: `${BASE_ENDPOINT}/showcases`,
          method: 'get',
          params: {
            query: {
              domain: encodeURIComponent(domain),
            },
          },
        }
      },
      transformResponse: (collections: Collection[]) => {
        if (!collections?.length) return []

        return collections
      },
    }),
  }),
})

export const {
  useFetchPublicCatalogObjectiveByIdQuery,
  useFetchPublicCatalogObjectivesQuery,
  useFetchPublicCatalogShowcasesQuery,
} = publicCatalogApi
